@import '~style-sheet-helpers/core.less';
@import '../../constants/spacing.module.less';

.insurance-promo {
  display: flex;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  border: solid 1px var(--default--border-color--12);
}

.insurance-section {
  border-bottom: none;
  width: 100%;
}

.header-green {
  background: var(--green-EDFDF5);
  color: var(--green-0C5B36);
}

.header-yellow {
  background: var(--yellow-FFF6EB);
  color: var(--gray-212c36);
}

.header-content-wrapper {
  padding: 0 @space-8;
}

.header-content {
  align-items: center;
  padding: @space-8 0;
}

.check-icon {
  color: var(--green-007733);
}

.warning-icon {
  color: var(--orange-F59E0B);
}

.content-body {
  background: var(--gray-F9FAFB);
  padding: @space-12 @space-16;
}

.promo-message {
  font-size: 13px;
  color: var(--gray-56595D);
  margin-bottom: @space-12;
}

.auto-insure-checkbox {
  margin-top: @space-12;
}
